import {
  ContentLayout,
  HeaderBreadcrumbs,
  Loader,
  TabPanel,
  CustomeDialog,
} from "../../../shared";
import { Button, Box, Tab, Tabs, Chip, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useCoupons } from "../hooks/useCoupons";
import {
  CouponsGeneralDetails,
  UnpublishDialogContent,
  UsageHistory,
} from "../components";
import { CouponsStore } from "../components/CouponsStore";
import { LedgerAccountsList } from "../../Configurations/components";
import { TabContextProvider } from "../../../store";

const couponStatusConfig = {
  1: {
    label: "Draft",
    color: "primary",
    variant: "outlined",
    sx: { bgcolor: "#1560D414", border: "none" },
  },
  2: {
    label: "Active",
    color: "success",
    variant: "outlined",
    sx: { border: "none !important" },
  },
  3: {
    label: "Paused",
    color: "success",
    sx: {},
  },
  4: {
    label: "Ended",
    color: "success",
    variant: "outlined",
    disabled: true,
    sx: { border: "none" },
  },
};

export const CouponDetailsList = () => {
  const { id } = useParams();

  const handleChange = (event, newValue) => {
    setCurentTab("CouponseDetails", newValue);
  };
  const {
    state,
    HandleFilterStores,
    handleStoreSelect,
    handleAssignStoretoCoupons,
    handleModal,
    DeleteStoreModal,
    handleDeleteStores,
    currentTab,
    setCurentTab,
    handlePlayPauseStatus,
    handleStatusChange,
    handleStatusModal,
    handleAllSelect,
    onChangeTitle,
    isEditable,
    globalData,
    onChangeusageHistoryFilter,
    resetusageHistoryFilters,
    gotoPageUsageHistory,
    setPageSizeUsageHistory,
    handleSortUsageHistory,
    downloadCouponsList,
  } = useCoupons({
    couponsById: id,
    isCoupons: false,
    isStore: true,
  });

  if (state.isBusy) {
    return <Loader />;
  }

  // Get status configuration
  const statusConfig = couponStatusConfig[state.data.active];
  const isDraft = state.data.active === 1;
  const isActive = state.data.active === 2;
  const isPaused = state.data.active === 3;

  return (
    <>
      <ContentLayout
        title={state.name}
        breadcrumbs={
          <HeaderBreadcrumbs
            links={[
              { name: "Dashboard", href: "/" },
              { name: "Coupons", href: "/coupons" },
              { name: state.name || "" },
            ]}
          />
        }
        chipType="other"
        statusContent={
          statusConfig && (
            <Chip
              label={statusConfig.label}
              color={statusConfig.color}
              variant={statusConfig.variant}
              size="small"
              disabled={statusConfig.disabled}
              sx={statusConfig.sx}
            />
          )
        }
        rightContent={
          <>
            {isPaused && (
              <img
                onClick={() => handleStatusModal("publish", true)}
                src="/icons/ic_play_blue2.svg"
                style={{ cursor: "pointer" }}
              />
            )}
            {isActive && (
              <Button
                aria-label="pause"
                color="primary"
                type="button"
                size="medium"
                variant="text"
                className="delte"
                sx={{ minWidth: "40px", p: "8px" }}
                onClick={() => handleStatusModal("unpublish", true)}
              >
                <img src="/icons/play_icon.svg" />
              </Button>
            )}
            <Button
              type="button"
              size="medium"
              variant="outlined"
              disabled={isDraft}
              onClick={() => downloadCouponsList(id)}
            >
              <img
                alt="export"
                src={
                  isDraft
                    ? "/icons/ic_download_gray.svg"
                    : "/icons/ic_download_blue.svg"
                }
                style={{ marginRight: "4px" }}
              />
              Download Coupons
            </Button>
            {isDraft && (
              <Button
                type="button"
                size="medium"
                variant="contained"
                disabled={state.isSaveButtonBusy}
                onClick={() => handleStatusModal("publish", true)}
              >
                Publish
              </Button>
            )}
          </>
        }
      >
        <Box
          className="sticky-Tab"
          sx={{ borderBottom: 1, borderColor: "divider", top: "104px" }}
        >
          <Tabs value={currentTab} onChange={handleChange}>
            <Tab label="Coupon Details" value="1" />
            <Tab label="Store" value="2" />
            <Tab label="Usage history" value="3" />
            <Tab label="Accounts" value="4" />
          </Tabs>
        </Box>

        <TabContextProvider value={currentTab}>
          <TabPanel sx={{ px: "0" }} value="1">
            {state.isBusy ? (
              <Loader />
            ) : (
              <CouponsGeneralDetails
                state={state}
                globalData={globalData}
                isEditable={isEditable}
              />
            )}
          </TabPanel>
          <TabPanel sx={{ px: "0" }} value="2">
            {state.isBusy ? (
              <Loader />
            ) : (
              <CouponsStore
                state={state}
                HandleFilterStores={HandleFilterStores}
                handleStoreSelect={handleStoreSelect}
                handleAssignStoretoCoupons={handleAssignStoretoCoupons}
                handleModal={handleModal}
                DeleteStoreModal={DeleteStoreModal}
                handleDeleteStores={handleDeleteStores}
                handleAllSelect={handleAllSelect}
                setCurentTab={setCurentTab}
                onChangeTitle={onChangeTitle}
              />
            )}
          </TabPanel>
          <TabPanel sx={{ px: "0" }} value="3">
            {state.isUsageHistoryLoading ? (
              <Loader />
            ) : (
              <UsageHistory
                state={state}
                onChangeusageHistoryFilter={onChangeusageHistoryFilter}
                resetusageHistoryFilters={resetusageHistoryFilters}
                gotoPageUsageHistory={gotoPageUsageHistory}
                setPageSizeUsageHistory={setPageSizeUsageHistory}
                handleSortUsageHistory={handleSortUsageHistory}
              />
            )}
          </TabPanel>
          <TabPanel sx={{ px: "0" }} value="4">
            <LedgerAccountsList type="promotion" />
          </TabPanel>
        </TabContextProvider>
      </ContentLayout>
      <CustomeDialog
        open={state.publishModalOpen}
        PaperProps={{
          sx: {
            width: "423px",
            height: "167px",
            p: "16px",
            gap: "12px",
          },
        }}
        title="Publish Coupon"
        content={
          <>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
            >
              <Typography fontSize="14px" fontWeight={400} lineHeight="16px">
                Are you sure you want to publish this coupon?
              </Typography>
              <Box display="flex" justifyContent="flex-end" mt={2} gap={1.5}>
                <Button
                  size="small"
                  variant="text"
                  color="info"
                  onClick={() => handleStatusModal("publish", false)}
                >
                  No
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  disabled={state.isSaveButtonBusy}
                  onClick={() => {
                    if (isDraft) {
                      handleStatusChange(id);
                    } else if (isPaused) {
                      handlePlayPauseStatus(id);
                    }
                    handleStatusModal("publish", false);
                  }}
                >
                  Yes
                </Button>
              </Box>
            </Box>
          </>
        }
      />

      <CustomeDialog
        open={state.unpublishModalOpen}
        PaperProps={{
          sx: {
            width: { xs: "90%", sm: 423, md: 480 },
            minHeight: "164px",
            p: "24px",
            gap: "12px",
          },
        }}
        title="Unpublish Coupon"
        content={
          <UnpublishDialogContent
            onClose={() => handleStatusModal("unpublish", false)}
            onConfirm={() => {
              handlePlayPauseStatus(id);
              handleStatusModal("unpublish", false);
            }}
            id={id}
            isUnPublishing={state.isSaveButtonBusy}
          />
        }
      />
    </>
  );
};
